import { useState, useEffect, useRef } from "react";
import { usePosicionDesplegable } from "../posicionDesplegable";
import Icon from "../Icon";

// Selector de página de Notion (campo separado de la descripción)
// Una sola barra de búsqueda: se escribe directamente y aparecen las coincidencias.
export default function NotionSelector({ linkedId, notionItems=[], onChange }) {
  const [open, setOpen] = useState(false);
  const [q,    setQ   ] = useState("");
  const ref = useRef(null);
  const panelRef = useRef(null);
  const { estilo: posicion } = usePosicionDesplegable(open, ref, panelRef, { altoMax: 260 });
  useEffect(() => {
    function h(e) { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setQ(""); } }
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const linked    = notionItems.find(i => i.external_id === linkedId);
  const pages     = notionItems.filter(i => i.item_type !== "database");
  const filtered  = (q.trim()
    ? pages.filter(i => (i.title||"").toLowerCase().includes(q.trim().toLowerCase()))
    : pages).slice(0, 12);

  const select = (item) => {
    onChange(item.external_id, item.parent_external_id);
    setOpen(false); setQ("");
  };
  const unlink = (e) => { e.stopPropagation(); onChange(null, null); };

  if (linked) {
    return (
      <div style={{ display:"flex", alignItems:"center", gap:6,
        padding:"5px 10px", borderRadius:8, border:"1px solid #bfdbfe",
        background:"var(--info-bg)", width:"fit-content", maxWidth:"100%" }}>
        {linked.icon && <span style={{fontSize:13}}>{linked.icon}</span>}
        <span style={{fontSize:12, fontWeight:600, color:"#1d4ed8", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>{linked.title}</span>
        <span style={{fontSize:11, padding:"1px 5px", borderRadius:20, background:"#dbeafe", color:"#1d4ed8", fontWeight:700, flexShrink:0}}>Notion</span>
        <button onMouseDown={unlink} style={{background:"transparent", border:"none", cursor:"pointer", color:"#93c5fd", fontSize:14, lineHeight:1, padding:"0 0 0 4px"}}>×</button>
      </div>
    );
  }

  return (
    <div ref={ref} style={{position:"relative", width:"100%"}}>
      <div style={{position:"relative"}}>
        <Icon name="search" size={11} color="var(--text3)"
          style={{position:"absolute", left:9, top:"50%", transform:"translateY(-50%)", pointerEvents:"none"}}/>
        <input aria-label="Buscar tarea de Notion"
          value={q}
          onChange={e=>{ setQ(e.target.value); setOpen(true); }}
          onFocus={()=>setOpen(true)}
          onKeyDown={e=>{
            if (e.key === "Enter" && filtered.length) { e.preventDefault(); select(filtered[0]); }
            if (e.key === "Escape") { e.stopPropagation(); setOpen(false); setQ(""); }
          }}
          placeholder="Buscar página de Notion…"
          style={{width:"100%", padding:"5px 8px 5px 26px", borderRadius:8,
            border:"1px solid var(--border-ctl)", background:"var(--surface)", color:"var(--text)",
            fontSize:12, fontFamily:"var(--font)"}}/>
      </div>
      {open && (
        <div ref={panelRef} style={{zIndex:200,
          background:"var(--surface)", border:"1px solid var(--border)", borderRadius:10,
          boxShadow:"var(--shadow-lg)", width:"min(440px, calc(100vw - 32px))", ...posicion}}>
          {filtered.map(item => (
            <div key={item.external_id} onMouseDown={()=>select(item)}
              style={{padding:"7px 12px", cursor:"pointer", display:"flex", alignItems:"center", gap:8, fontSize:12}}
              onMouseEnter={e=>e.currentTarget.style.background="var(--bg)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              {item.icon
                ? <span style={{fontSize:14, flexShrink:0}}>{item.icon}</span>
                : <span style={{fontSize:14, flexShrink:0, color:"var(--text3)"}}>📄</span>}
              <span style={{flex:1, fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>{item.title}</span>
            </div>
          ))}
          {filtered.length === 0 && <div style={{padding:"12px", fontSize:12, color:"var(--text3)", textAlign:"center"}}>Sin resultados</div>}
        </div>
      )}
    </div>
  );
}

